// LIST
export const FETCH_REVIEWS_REPLY = "app/ReviewsReply/FETCH_REVIEWS_REPLY";
export const FETCH_REVIEWS_REPLY_SUCCESS =
  "app/ReviewsReply/FETCH_REVIEWS_REPLY_SUCCESS";
export const FETCH_REVIEWS_REPLY_FAILURE =
  "app/ReviewsReply/FETCH_REVIEWS_REPLY_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/ReviewsReply/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/ReviewsReply/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/ReviewsReply/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_REVIEWS_REPLY = "app/ReviewsReply/ADD_REVIEWS_REPLY";
export const ADD_REVIEWS_REPLY_SUCCESS =
  "app/ReviewsReply/ADD_REVIEWS_REPLY_SUCCESS";
export const ADD_REVIEWS_REPLY_FAILURE =
  "app/ReviewsReply/ADD_REVIEWS_REPLY_FAILURE";
// EDIT
export const EDIT_REVIEWS_REPLY = "app/ReviewsReply/EDIT_REVIEWS_REPLY";
export const EDIT_REVIEWS_REPLY_SUCCESS =
  "app/ReviewsReply/EDIT_REVIEWS_REPLY_SUCCESS";
export const EDIT_REVIEWS_REPLY_FAILURE =
  "app/ReviewsReply/EDIT_REVIEWS_REPLY_FAILURE";

export const DELETE_REVIEWS_REPLY = "app/ReviewsReply/DELETE_REVIEWS_REPLY";
export const DELETE_REVIEWS_REPLY_SUCCESS =
  "app/ReviewsReply/DELETE_REVIEWS_REPLY_SUCCESS";
export const DELETE_REVIEWS_REPLY_FAILURE =
  "app/ReviewsReply/DELETE_REVIEWS_REPLY_FAILURE";
